__turbopack_context__.v({
  "thumb": "Switch-module__JqniFW__thumb",
  "track": "Switch-module__JqniFW__track",
  "wrap": "Switch-module__JqniFW__wrap",
});
